import CardProduto, {Produto} from "../../components/CardProduto/CardProduto";
import api from "../../utils/axios/api";
import styles from "./favoritos.module.css";
import { useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

function Favoritos() {
  const [favorites, setFavorites]: any = useState<any>([]);

  const getUserID = () => {
    const clientId = localStorage.getItem('clientId');
    if (clientId) {
      
      api.get(`/favorite/client/${clientId}`)
      .then((response) => {
    // Mapeia os favoritos para extrair apenas o produto
    const products = response.data.map((item:any) => item.product);
    setFavorites(products);
  })
  .catch((error) => {
    console.error("Error fetching client favorites", error);
  });

    } else {
      console.error("Client ID not found");
    }
  }

  useEffect(() => {
    getUserID();
  }, []);
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.local}>
        <span> {t(`accountMenu.favorites`)}</span>
      </div>

      <div className={styles.horizontalLine} />

      <div className={styles.wrapperProducts}>
        {favorites.map((favorites: Produto) => (
          <CardProduto key={favorites.id} produto={favorites} />
        ))}
      </div>
    </div>
  );
}

export default Favoritos;
